import { Role } from '@/core/components/auth/auth.types'
import { redirect } from '@tanstack/react-router'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/dashboard/resellers/create/')({
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (auth.user?.role !== Role['Internal']) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
})
